<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10"
  >
    <!--
      Background overlay, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
      Modal panel, show/hide based on modal state.
  
      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
          Downgrading to VIP
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4 text-left">
        <Alert v-if="showAlert" :text="alertText" type="info"></Alert>
        <p>
          If you downgrade to the VIP plan, you will lose access to:
          <ul class="list-disc ml-6 mt-2">
            <li>
              <strong>Custom Templates</strong> – Default templates will replace your current custom templates.
            </li>
            <li>
              <strong>Sending messages using your own number</strong> – Messages will be sent from one of our numbers instead of yours.
            </li>
            <li>
              <strong>Marketing campaigns</strong>
            </li>
            <li>
              <strong>Upsell</strong>
            </li>
          </ul>
        </p>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="gotoPlan"
          >
            <span
              class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
            >
              Ok, Downgrade to VIP
            </span>
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "./Alert.vue";

export default {
  components: {
    Alert
  },
  data() {
    return {
      recoveredValue: {},
      showAlert: false,
      alertText: "You have recovered {{amount}} in the last 30 days"
    };
  },
  created() {
    // Add event listener for escape key
    document.addEventListener("keydown", this.handleEscapeKey);

    this.$store.dispatch("getTotalRecoveredValue").then((response) => {
      this.recoveredValue = response;
      this.alertText = this.alertText.replace(
        "{{amount}}",
        this.recoveredValue.totalRecoveredValue
      );
      if (this.recoveredValue.totalRecoveredValue) {
        this.showAlert = true;
      }
      console.log(response);
    });
  },
  destroyed() {
    // Remove event listener when component is destroyed
    document.removeEventListener("keydown", this.handleEscapeKey);
  },
  methods: {
    handleEscapeKey(event) {
      if (event.key === "Escape") {
        this.close();
      }
    },
    gotoPlan() {
      this.$emit("downgrade");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
